import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { createUserStore } from './userStore'
import { createToolkitsStore } from './toolkitsStore'
import { createNavigationStore } from './navigationStore'
import { createDirectLinkStore } from './directLinkStore'
import encryptedStorage from '../../utils/encryptedStorage'

export const useGlobalStore = create(
	process.env.NODE_ENV !== 'production' &&
		typeof window !== 'undefined' &&
		// eslint-disable-next-line no-underscore-dangle
		window.__REDUX_DEVTOOLS_EXTENSION__
		? devtools(
				persist(
					(...a) => ({
						...createUserStore(...a),
						...createToolkitsStore(...a),
						...createNavigationStore(...a),
						...createDirectLinkStore(...a)
					}),
					{
						name: 'soteria-store'
					}
				),
				{
					name: 'soteria-store'
				}
			)
		: persist(
				(...a) => ({
					...createUserStore(...a),
					...createToolkitsStore(...a),
					...createNavigationStore(...a),
					...createDirectLinkStore(...a)
				}),
				{
					name: import.meta.env.VITE_GLOBAL_STORE_NAME,
					storage: encryptedStorage
				}
			)
)
